import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import { toLocalDate } from "../../helpers"
import { getImage } from "gatsby-plugin-image"
import { BgImage } from "gbimage-bridge"
import { css } from "@emotion/react"

const ContentWrapper = styled.div`
  background: rgba(157, 157, 156, 0.72);
  border-radius: 5px;
  padding: 0.1rem 0.7rem 0;
  height: 33%;
  min-height: 90px;
  overflow: hidden;
`

const MyDate = styled.div`
  color: ${props => props.theme.colors.blogNewsDate};
  margin-bottom: 0.2rem;
`

const Title = styled.div`
  & > span {
    color: ${props => props.theme.colors.blogNewsDate};
    font-size: ${props => props.fontSize};
    font-weight: 600;
    height: 100%;
    text-align: left;
    overflow: hidden;
  }
  p {
    color: white;
  }
  a {
    display: none;
  }
`

const LinkWrapper = styled.div`
  flex: 1;
  flex-basis: ${props => props.flexBasis};
  box-sizing: border-box;
  margin-bottom: 1rem;
  min-height: ${props => props.height};
  ${props => props.theme.tablet} {
    min-height: 340px;
    flex-basis: 100%;
  }
`

const StyledLink = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;

  ${props => props.theme.tablet} {
  }
`
const Excerpt = styled.p`
  ${props => props.theme.tablet} {
    display: none;
  }
`
const PostBackground = ({ children, images, idx, wpImage }) => {
  const imageWithSrc = images[idx]
  const image = getImage(imageWithSrc.node)

  const backgroundStyles = css`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
    min-height: 240px;
    border: 1px solid rgb(229, 229, 229);
    border-radius: 5px;
    margin: 0 0.5rem;
    overflow: hidden;
    @media (max-width: 768px) {
      margin: 0;
    }
    a {
      color: black;
      font-size: 0.9rem;
    }
  `

  if (wpImage) {
    return (
      <div
        css={css`
          background-image: url(${wpImage.node.sourceUrl});
          background-color: #cccccc;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          ${backgroundStyles}
        `}
      >
        {children}
      </div>
    )
  }

  return (
    <BgImage
      image={image}
      css={css`
        ${backgroundStyles}
      `}
    >
      {children}
    </BgImage>
  )
}

const NewsCard = ({
  post,
  idx,
  postImages,
  flexBasis,
  height,
  excerpt,
  fontSize,
}) => {
  return (
    <LinkWrapper flexBasis={flexBasis} height={height}>
      <PostBackground
        wpImage={post.featuredImage}
        images={postImages}
        idx={idx}
      >
        <StyledLink to={`/news/${post.slug}`} key={post.id}>
          <ContentWrapper>
            <MyDate>{toLocalDate(post.date)}</MyDate>
            <Title fontSize={fontSize}>
              <span dangerouslySetInnerHTML={{ __html: post.title }} />
              {excerpt && (
                <Excerpt dangerouslySetInnerHTML={{ __html: excerpt }} />
              )}
            </Title>
          </ContentWrapper>
        </StyledLink>
      </PostBackground>
    </LinkWrapper>
  )
}

export default NewsCard
